"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _constant = require("../constant");
var _getConcentrations = _interopRequireDefault(require("./get-concentrations"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var getMajor = function getMajor(student, major, other) {
  var majorName = other && student[other];
  return (majorName || student["".concat(major, "Name")]) + (0, _getConcentrations.default)([student["".concat(major, "Concentration")], student["".concat(major, "SecondConcentration")]]);
};
var getMajorName = function getMajorName(student) {
  switch (student.specialization) {
    case '6':
      return _constant.majors.UNDECIDED_MAJOR;
    case '5':
      return "".concat(getMajor(student, _constant.majors.FIRST_MAJOR, _constant.majors.OTHER_FIRST_MAJOR), " (").concat(_constant.majors.INTENDED_MAJOR, ")");
    case '4':
      return "".concat(getMajor(student, _constant.majors.FIRST_MAJOR, _constant.majors.OTHER_FIRST_MAJOR), ", ").concat(getMajor(student, _constant.majors.SECOND_MAJOR, _constant.majors.OTHER_SECOND_MAJOR));
    case '3':
      return "".concat(getMajor(student, _constant.majors.FIRST_MAJOR, _constant.majors.OTHER_FIRST_MAJOR), ", ").concat(getMajor(student, _constant.majors.SECOND_MAJOR, _constant.majors.OTHER_SECOND_MAJOR), ", ").concat(getMajor(student, _constant.majors.THIRD_MAJOR, _constant.majors.OTHER_THIRD_MAJOR));
    case '2':
      return "".concat(getMajor(student, _constant.majors.FIRST_MAJOR, _constant.majors.OTHER_FIRST_MAJOR), ", ").concat(getMajor(student, _constant.majors.SECOND_MAJOR, _constant.majors.OTHER_SECOND_MAJOR));
    case '1':
      return "".concat(getMajor(student, _constant.majors.FIRST_MAJOR, _constant.majors.OTHER_FIRST_MAJOR));
    default:
      return '';
  }
};
var _default = getMajorName;
exports.default = _default;